import { VuexModule, Action } from "vuex-class-modules";
import { BaseChildDocumentService } from "@/services/BaseDocumentService";
import { globalStore } from "./GlobalStore";
import _ from "lodash";
import { BaseClientDocument, BaseDocument } from "@/models/BaseDocuments";

export abstract class BaseChildDocumentStore<
  TEntity extends BaseClientDocument,
  TParentEntity extends BaseDocument,
  TService extends BaseChildDocumentService<TEntity>
> extends VuexModule {
  abstract current: TEntity;
  abstract parent: TParentEntity;
  abstract newEntity(): TEntity;
  abstract get service(): TService;
  entities: TEntity[] = [];

  @Action
  async getAll(): Promise<void> {
    try {
      globalStore.setIsBusy(true);
      const items = await this.service.getAll(this.parent.id);
      this.entities = items.map((x) => _.merge(this.newEntity(), x));
    } finally {
      globalStore.setIsBusy(false);
    }
  }

  @Action
  new(): void {
    const newValue = this.newEntity();
    _.merge(newValue, _.omit(this.parent, _.keys(new BaseDocument())));
    this.current = newValue;
  }

  @Action
  setParent(parent: TParentEntity): void {
    this.parent = parent;
  }

  @Action
  async select(id: string): Promise<void> {
    const entity = this.newEntity();
    const data = await this.service.get(id);
    _.merge(entity, data);
    this.current = entity;
  }

  @Action
  async getByClientId(id: string): Promise<void> {
    try {
      globalStore.setIsBusy(true);
      const items = await this.service.getByClientId(id);
      this.entities = items.map((x) => _.merge(this.newEntity(), x));
    } finally {
      globalStore.setIsBusy(false);
    }
  }
  @Action
  async save(data: TEntity): Promise<boolean> {
    try {
      const savedEntity = await this.service.save(data);
      const newEntity = this.newEntity();
      _.merge(newEntity, savedEntity);
      this.current = newEntity;
      return true;
    } catch {
      return false;
    }
  }
}
